import type {
  FormControlProps,
  TypedUseControllerProps,
} from '@ipfabric/ui-components/FormControl/FormControl.types';
import { type FieldValues, useController } from 'react-hook-form';
import { TagNameInput, type TagNameInputProps } from './TagNameInput';

export type FormTagNameInputProps<TFieldValues extends FieldValues> =
  TypedUseControllerProps<TFieldValues, string[]> &
    FormControlProps<TagNameInputProps> & {
      /**
       * Error raised outside RHF, e.g. a failed tag-name fetch (`FormControlProps`
       * strips `error` since RHF owns that slot). Field validation wins if both are set.
       */
      externalError?: string;
    };

/**
 * React Hook Form binding for {@link TagNameInput}, mirroring FormIPSubnetField.
 */
export const FormTagNameInput = <TFieldValues extends FieldValues>({
  disabled,
  externalError,
  ...props
}: FormTagNameInputProps<TFieldValues>) => {
  const {
    field: { ref, value, ...field },
    formState: { errors },
  } = useController(props);

  const error = errors[props.name]?.message?.toString() ?? externalError;

  return (
    <TagNameInput
      {...props}
      {...field}
      disabled={disabled}
      error={error}
      value={value ?? []}
    />
  );
};
